import { render, staticRenderFns } from "./Tambah.vue?vue&type=template&id=eec1c9c2&"
import script from "./Tambah.vue?vue&type=script&lang=js&"
export * from "./Tambah.vue?vue&type=script&lang=js&"
import style0 from "./Tambah.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports